import { Outlet, Link } from "react-router-dom"
import { useEffect, useRef, useState } from 'react'
import { useRefreshMutation } from "./authApiSlice"
import { useSelector } from 'react-redux'
import { selectCurrentToken } from "./authSlice"
import PulseLoader from 'react-spinners/PulseLoader'
import usePersist from "../hooks/usePersist"
import styled from 'styled-components'
import { Paper, Typography, Button } from '@mui/material'
import { CommonButton } from '../../Styles/CommonStyles'

// console.log("persist")

const ErrorContainer = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  max-width: 400px;
  margin: 100px auto;
  text-align: center;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
`

const ErrorMessage = styled(Typography)`
  color: #d32f2f;
  margin-bottom: 20px !important;
  font-size: 16px !important;
`

const StyledLink = styled(Link)`
  text-decoration: none;
`

const LoginButton = styled(CommonButton)`
  && {
    height: 45px;
    background: linear-gradient(45deg, #a961f1, #57ccf4);
    color: white;
    font-weight: 600;
    text-transform: none;
    border-radius: 12px;
    margin-top: 10px;
    
    &:hover {
      background: linear-gradient(45deg, #5C5891, #57ccf4);
    }
  }
`

const PersistLogin = () => {

    const [persist] = usePersist()
    const token = useSelector(selectCurrentToken)
    const effectRan = useRef(false)

    const [trueSuccess, setTrueSuccess] = useState(false)

    const [refresh, {
        isUninitialized,
        isLoading,
        isSuccess,
        isError,
        error
    }] = useRefreshMutation()

    // console.log(effectRan.current)

    useEffect(() => {

        if (effectRan.current === true || process.env.NODE_ENV !== 'development') { // React 18 Strict Mode

            const verifyRefreshToken = async () => {
                // console.log('verifying refresh token')
                try {
                    const response = await refresh();
                    const { accessToken } = response.data
                    // console.log(accessToken)
                    setTrueSuccess(true)
                }
                catch (err) {
                    console.error(err)
                }
            }
        

            if (!token && persist) verifyRefreshToken()
        }

        return () => effectRan.current = true

        // eslint-disable-next-line
    }, [])


    let content
    if (!persist) { // persist: no
        // console.log('no persist')
        content = <Outlet />
    } else if (isLoading) { //persist: yes, token: no
        // console.log('loading')
        content = <PulseLoader color={"#FFF"} />
    } else if (isError) { //persist: yes, token: no
        // console.log('error')
        content = (
            <ErrorContainer elevation={3}>
                <ErrorMessage variant="h6">
                    {error?.data?.message || "Your session has expired"}
                </ErrorMessage>
                <StyledLink to="/">
                    <LoginButton>
                        Sign In Again
                    </LoginButton>
                </StyledLink>
            </ErrorContainer>
        )
    } else if (isSuccess && trueSuccess) { //persist: yes, token: yes
        // console.log('success')
        content = <Outlet />
    } else if (token && isUninitialized) { //persist: yes, token: yes
        // console.log('token and uninit')
        // console.log(isUninitialized)
        content = <Outlet />
    }

    return content
}
export default PersistLogin